(function () {
  'use strict';

  var BLOG_HANDLE = 'recipes';
  var FETCH_LIMIT = 10;
  var DISPLAY_LIMIT = 4;
  var recipeCache = {};

  // ── Search results page ──────────────────────────────────────────────────

  function initSearchPage() {
    // Recipes only appear on page 1
    var params = new URLSearchParams(window.location.search);
    var page = parseInt(params.get('page') || '1', 10);
    if (page > 1) return;

    var band = document.getElementById('runamok-recipe-results');
    if (!band) return;

    var searchTerm = band.dataset.searchTerm;
    if (!searchTerm) return;

    var grid = band.querySelector('.runamok-recipe-grid');
    var viewAllLink = band.querySelector('.runamok-search-recipes-link');

    if (!grid) return;

    if (viewAllLink) {
      viewAllLink.href = '/search?q=' + encodeURIComponent(searchTerm) + '&type=article&options%5Bprefix%5D=last';
    }

    fetchRecipes(searchTerm, function (articles) {
      if (!articles.length) return;

      var cardStyle   = band.dataset.blogCardStyle || 'standard';
      var badgePos    = band.dataset.badgePosition || 'bottom left';
      var colorScheme = band.dataset.colorScheme   || '1';

      grid.innerHTML = articles.slice(0, DISPLAY_LIMIT).map(function (a) {
        return buildCard(a, cardStyle, badgePos, colorScheme);
      }).join('');

      if (articles.length > DISPLAY_LIMIT) {
        band.classList.add('runamok-recipes--has-more');
      }

      band.removeAttribute('hidden');
    });
  }

  // ── Modal (predictive search) ─────────────────────────────────────────────

  function populateModalBand(searchTerm, container) {
    var band = container.querySelector('#runamok-modal-recipe-results');
    if (!band) return;

    var list = band.querySelector('.runamok-modal-recipe-list');
    var viewAllLink = band.querySelector('.runamok-modal-recipe-viewall');
    var footer = band.querySelector('.runamok-modal-recipe-band__footer');

    if (!list) return;

    if (viewAllLink) {
      viewAllLink.href = '/search?q=' + encodeURIComponent(searchTerm) + '&type=article&options%5Bprefix%5D=last';
    }

    fetchRecipes(searchTerm, function (articles) {
      if (!articles.length) {
        band.setAttribute('hidden', '');
        return;
      }

      list.innerHTML = articles.slice(0, DISPLAY_LIMIT).map(buildModalItem).join('');

      if (footer) {
        if (articles.length > DISPLAY_LIMIT) {
          footer.removeAttribute('hidden');
        } else {
          footer.setAttribute('hidden', '');
        }
      }

      band.removeAttribute('hidden');
    });
  }

  // ── Shared fetch with cache ───────────────────────────────────────────────

  function fetchRecipes(searchTerm, callback) {
    var cacheKey = searchTerm.toLowerCase().trim();
    if (recipeCache[cacheKey] !== undefined) {
      callback(recipeCache[cacheKey]);
      return;
    }

    fetch(
      '/search/suggest.json?q=' + encodeURIComponent(searchTerm) +
      '&resources[type]=article' +
      '&resources[limit]=' + FETCH_LIMIT
    )
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var all = (data.resources && data.resources.results && data.resources.results.articles) || [];
        var articles = all.filter(function (a) {
          return a.url && a.url.indexOf('/blogs/' + BLOG_HANDLE + '/') !== -1;
        });
        recipeCache[cacheKey] = articles;
        callback(articles);
      })
      .catch(function () {
        recipeCache[cacheKey] = [];
        callback([]);
      });
  }

  // ── Card builders ─────────────────────────────────────────────────────────

  function buildCard(article, cardStyle, badgePos, colorScheme) {
    var hasImage = !!article.image;
    var mediaClass = hasImage ? 'card--media' : 'card--text';
    var cardColorClass = cardStyle === 'card' ? ' color-scheme-' + esc(colorScheme) + ' gradient' : '';
    var innerColorClass = cardStyle === 'standard' ? ' color-scheme-' + esc(colorScheme) + ' gradient' : '';

    var imgHtml = hasImage
      ? '<div class="article-card__image-wrapper card__media">' +
          '<div class="article-card__image media media--hover-effect">' +
            '<img src="' + esc(article.image) + '"' +
                 ' alt="' + esc(article.title) + '"' +
                 ' width="533" height="533" loading="lazy" class="motion-reduce">' +
          '</div>' +
        '</div>'
      : '';

    var dateHtml = '';
    if (article.published_at) {
      try {
        var d = new Date(article.published_at);
        dateHtml = '<span class="circle-divider">' +
          d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).toUpperCase() +
          '</span>';
      } catch (e) { /* skip date */ }
    }

    var titleLink = '<a href="' + esc(article.url) + '" class="full-unstyled-link">' +
      esc(truncate(article.title, 50)) + '</a>';

    return '<li class="grid__item runamok-recipe-card-item">' +
      '<div class="article-card-wrapper card-wrapper underline-links-hover">' +
        '<div class="card article-card card--' + esc(cardStyle) + ' ' + mediaClass + cardColorClass + '">' +
          '<div class="card__inner' + innerColorClass + ' ratio" style="--ratio-percent: 100%;">' +
            imgHtml +
            '<div class="card__content">' +
              '<div class="card__information">' +
                '<h3 class="card__heading">' + titleLink + '</h3>' +
              '</div>' +
              '<div class="card__badge ' + esc(badgePos) + '">' +
                '<span class="badge color-scheme-' + esc(colorScheme) + '">Recipe</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="card__content">' +
            '<div class="card__information">' +
              '<h3 class="card__heading">' + titleLink + '</h3>' +
              '<div class="article-card__info caption-with-letter-spacing h5">' +
                dateHtml +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</li>';
  }

  function buildModalItem(article) {
    var hasImage = !!article.image;
    var linkClass = 'predictive-search__item link link--text' +
      (hasImage ? ' predictive-search__item--link-with-thumbnail' : '');
    var imgHtml = hasImage
      ? '<img class="predictive-search__image" src="' + esc(article.image) + '"' +
          ' alt="' + esc(article.title) + '" width="50" height="50" style="object-fit:cover">'
      : '';
    return '<li class="predictive-search__list-item" role="option" aria-selected="false">' +
      '<a href="' + esc(article.url) + '" class="' + linkClass + '" tabindex="-1">' +
        imgHtml +
        '<div class="predictive-search__item-content predictive-search__item-content--centered">' +
          '<p class="predictive-search__item-heading h5">' + esc(article.title) + '</p>' +
        '</div>' +
      '</a>' +
    '</li>';
  }

  // ── Utilities ─────────────────────────────────────────────────────────────

  function truncate(str, max) {
    if (!str) return '';
    return str.length > max ? str.slice(0, max - 1) + '\u2026' : str;
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── Init ──────────────────────────────────────────────────────────────────

  window.RunamokRecipes = { populateModalBand: populateModalBand };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchPage);
  } else {
    initSearchPage();
  }
})();
